export default {
    "MAIN": "Main",
    "ADDON": "Additional",
    "MACHINE": "Machine"
};